import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Renders an image from one of three possible sources:
//   1. data:... URI  → used directly (mobile app stores inline base64)
//   2. http(s)://... → used directly (external URL)
//   3. relative path → fetched as authed blob via /api/files/{path}
export default function AuthedImage({ path, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);
  const isDataUri = typeof path === "string" && /^data:/i.test(path);
  const isAbsoluteUrl = typeof path === "string" && /^https?:\/\//i.test(path);
  const direct = isDataUri || isAbsoluteUrl;

  useEffect(() => {
    if (!path || direct) {
      setSrc(null);
      return;
    }
    let url;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch {
        if (!cancelled) setSrc(null);
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path, direct]);

  if (!path) return null;
  if (direct) return <img src={path} alt={alt} className={className} data-testid="authed-image-direct" />;
  if (!src) return <div className={`bg-sand-200 animate-pulse ${className}`} data-testid="authed-image-loading" />;
  return <img src={src} alt={alt} className={className} data-testid="authed-image-fetched" />;
}
